// lib/stripe/handleCheckout.ts

export async function handlePlanCheckout(params: {
  planId: string;
  interval: "monthly" | "quarterly" | "semiannual";
  interviewHoursPerMonth?: number;
  language?: string;
}): Promise<void> {
  const response = await fetch("/api/billing/create-checkout-session", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(params),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || "Failed to create checkout session");
  }

  if (!data.url) {
    throw new Error("No checkout URL returned");
  }

  window.location.href = data.url;
}
